(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[832],{

/***/ 2135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2132);


var MetaBlock = function(props) {
    var title = props.title, description = props.description, leadImage = props.leadImage, keywords = props.keywords, children = props.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                })
            }),
            leadImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: leadImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image",
                        content: leadImage
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaBlock);


/***/ }),

/***/ 1200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(109);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4656);
/* harmony import */ var _not_found_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9163);
/* harmony import */ var _not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var NotFound = function() {
    var theme = (0,_contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* .useThemeContext */ .TC)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        theme.setThemeStyle(_contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* .ThemeStyles.Light */ .Cz.Light);
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pageNotFound),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().number),
                children: "404"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
                children: "Oops! The page you are looking for doesn\u2019t exist. Try the button below..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/",
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().buttonBack),
                "aria-label": "Back to home",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    children: "Back to home"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFound);


/***/ }),

/***/ 9073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9113);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _BaseModel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3385);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


var PageModel = /*#__PURE__*/ function(BaseModel1) {
    "use strict";
    _inherits(PageModel, BaseModel1);
    var _super = _createSuper(PageModel);
    function PageModel() {
        _classCallCheck(this, PageModel);
        var _this;
        _this = _super.call(this, {
            modelName: "page"
        });
        _this.convertBuilderURL2Slug = function(url) {
            if (!url) return null;
            var ref;
            return (ref = url.replace(/^(\/page)/, "")) !== null && ref !== void 0 ? ref : "";
        };
        _this.convertSlug2BuilderURL = function(slug) {
            if (!slug) return null;
            return "/page/".concat(slug);
        };
        _this.getByUrl = function(url) {
            return _this.builder.get(_this.modelName, {
                userAttributes: {
                    urlPath: url
                }
            }).toPromise();
        };
        var _this1 = _assertThisInitialized(_this);
        _this.getAllPage = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var includeUnpublished, includeDraft, fields, draft, pages, _args = arguments;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        includeUnpublished = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false, includeDraft = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false, fields = _args.length > 2 ? _args[2] : void 0;
                        draft = includeDraft !== null && includeDraft !== void 0 ? includeDraft : "draft";
                        _ctx.next = 4;
                        return _this1.builder.getAll(_this1.modelName, {
                            options: {
                                noTargeting: true,
                                includeUnpublished: includeUnpublished
                            },
                            query: {
                                published: {
                                    $ni: [
                                        "archived",
                                        draft
                                    ]
                                }
                            },
                            fields: fields,
                            omit: "data.state"
                        });
                    case 4:
                        pages = _ctx.sent;
                        return _ctx.abrupt("return", pages);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this2 = _assertThisInitialized(_this);
        _this.findPage = function() {
            var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(filter) {
                var ref;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if ((ref = filter.params) === null || ref === void 0 ? void 0 : ref.url) {
                                filter.params.url = _this2.convertSlug2BuilderURL(filter.params.url) || undefined;
                            }
                            return _ctx.abrupt("return", _this2.find(filter));
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(filter) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    return PageModel;
}(_BaseModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (new PageModel());


/***/ }),

/***/ 7637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CF": function() { return /* binding */ getAsyncServerSideProps; },
/* harmony export */   "LV": function() { return /* binding */ getBlockDataMap; }
/* harmony export */ });
/* unused harmony exports createStaticPaths, createStaticProps */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9113);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _builder_io_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1258);
/* harmony import */ var _builder_io_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_builder_io_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_roomstay_blog_all_articles_roomstay_blog_all_articles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4068);
/* harmony import */ var _components_roomstay_blog_all_articles_roomstay_blog_all_articles_builder_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1123);
/* harmony import */ var _components_roomstay_blog_blog_hero_roomstay_blog_blog_hero_builder_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4375);
/* harmony import */ var _components_roomstay_blog_featured_articles_roomstay_blog_featured_articles_builder_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8447);
/* harmony import */ var _components_roomstay_blog_highlight_article_roomstay_blog_highlight_article_builder_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7473);
/* harmony import */ var _models_ArticleModel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4618);
/* harmony import */ var _models_PageModel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9073);
/* harmony import */ var _utils_Article__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5269);
/* harmony import */ var _shared_constant__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(678);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var getAsyncServerSideProps = function(page) {
    var _obj;
    return (0,_builder_io_utils__WEBPACK_IMPORTED_MODULE_1__.getAsyncProps)(page, (_obj = {}, _defineProperty(_obj, _components_roomstay_blog_blog_hero_roomstay_blog_blog_hero_builder_component__WEBPACK_IMPORTED_MODULE_4__.RoomstayBlogHomeHeroBuilderConfig.name, function() {
        return _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, leadArticle, articles;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.t0 = _toArray;
                        _ctx.next = 3;
                        return (0,_utils_Article__WEBPACK_IMPORTED_MODULE_9__/* .getHeroArticles */ .xM)();
                    case 3:
                        _ctx.t1 = _ctx.sent;
                        ref = (0, _ctx.t0)(_ctx.t1);
                        leadArticle = ref[0];
                        articles = ref.slice(1);
                        return _ctx.abrupt("return", {
                            leadArticle: leadArticle || null,
                            articles: articles
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }), _defineProperty(_obj, _components_roomstay_blog_highlight_article_roomstay_blog_highlight_article_builder_component__WEBPACK_IMPORTED_MODULE_6__.RoomstayBlogHighlightArticleConfig.name, function(props) {
        return _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var fixedArticle;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_utils_Article__WEBPACK_IMPORTED_MODULE_9__/* .getHighlightArticle */ .np)(props.article);
                    case 2:
                        fixedArticle = _ctx.sent;
                        return _ctx.abrupt("return", {
                            fixedArticle: fixedArticle || null
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }), _defineProperty(_obj, _components_roomstay_blog_featured_articles_roomstay_blog_featured_articles_builder_component__WEBPACK_IMPORTED_MODULE_5__.RoomstayBlogFeaturedArticlesConfig.name, function(props) {
        return _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var fixedArticles;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_utils_Article__WEBPACK_IMPORTED_MODULE_9__/* .getFeaturedArticles */ .L9)(props.articles);
                    case 2:
                        fixedArticles = _ctx.sent;
                        return _ctx.abrupt("return", {
                            fixedArticles: fixedArticles
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }), _defineProperty(_obj, _components_roomstay_blog_all_articles_roomstay_blog_all_articles_builder_component__WEBPACK_IMPORTED_MODULE_3__.RoomstayBlogAllArticlesConfig.name, function(props) {
        return _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var itemsPerPage, fixedArticles;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        itemsPerPage = (0,_utils_Article__WEBPACK_IMPORTED_MODULE_9__/* .getItemsPerPage */ .ZU)(_components_roomstay_blog_all_articles_roomstay_blog_all_articles__WEBPACK_IMPORTED_MODULE_2__/* .ROWS */ .ng, 0, _components_roomstay_blog_all_articles_roomstay_blog_all_articles__WEBPACK_IMPORTED_MODULE_2__/* .TEMPLATE */ .hv);
                        _ctx.next = 3;
                        return (0,_utils_Article__WEBPACK_IMPORTED_MODULE_9__/* .getMoreArticles */ ._p)(props.offset === undefined ? _components_roomstay_blog_all_articles_roomstay_blog_all_articles__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_OFFSET */ .Yb : props.offset, itemsPerPage);
                    case 3:
                        fixedArticles = _ctx.sent;
                        return _ctx.abrupt("return", {
                            fixedArticles: fixedArticles,
                            currentRow: _components_roomstay_blog_all_articles_roomstay_blog_all_articles__WEBPACK_IMPORTED_MODULE_2__/* .ROWS */ .ng,
                            defaultOffset: itemsPerPage,
                            isLoading: false
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }), _obj));
};
var getBlockDataMap = function(content) {
    var ref2, ref1;
    return ((ref2 = content.data) === null || ref2 === void 0 ? void 0 : (ref1 = ref2.blocks) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(rs, block) {
        var ref;
        if (!(block === null || block === void 0 ? void 0 : (ref = block.component) === null || ref === void 0 ? void 0 : ref.name)) return rs;
        return _objectSpread({}, rs, _defineProperty({}, block.component.name, block.component.options));
    }, {})) || {};
};
function getPageStaticPaths(includeUnpublished) {
    return _getPageStaticPaths.apply(this, arguments);
}
function _getPageStaticPaths() {
    _getPageStaticPaths = _asyncToGenerator(regeneratorRuntime.mark(function _callee(includeUnpublished) {
        var pages, paths;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return PageModel.getAllPage(includeUnpublished);
                case 2:
                    pages = _ctx.sent;
                    paths = pages.filter(function(page) {
                        return page.data.url && page.data.url !== "/page/".concat(HOME_PAGE_NAME);
                    }).map(function(page) {
                        return PageModel.convertBuilderURL2Slug(page.data.url);
                    });
                    return _ctx.abrupt("return", {
                        paths: paths,
                        fallback: true
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getPageStaticPaths.apply(this, arguments);
}
function getArticleStaticPaths(includeUnpublished) {
    return _getArticleStaticPaths.apply(this, arguments);
}
function _getArticleStaticPaths() {
    _getArticleStaticPaths = _asyncToGenerator(regeneratorRuntime.mark(function _callee(includeUnpublished) {
        var pages, paths;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return ArticleModel.getAllArticles(includeUnpublished);
                case 2:
                    pages = _ctx.sent;
                    paths = pages.filter(function(page) {
                        return page.data.url;
                    }).map(function(page) {
                        return ArticleModel.convertBuilderURL2Slug(page.data.url);
                    });
                    return _ctx.abrupt("return", {
                        paths: paths,
                        fallback: true
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getArticleStaticPaths.apply(this, arguments);
}
function createStaticPaths(prefix, includeUnpublished) {
    return _createStaticPaths.apply(this, arguments);
}
function _createStaticPaths() {
    _createStaticPaths = _asyncToGenerator(regeneratorRuntime.mark(function _callee(prefix, includeUnpublished) {
        var pagesPage, pageArticle, paths;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getPageStaticPaths(includeUnpublished);
                case 2:
                    pagesPage = _ctx.sent.paths;
                    _ctx.next = 5;
                    return getArticleStaticPaths(includeUnpublished);
                case 5:
                    pageArticle = _ctx.sent.paths;
                    paths = _toConsumableArray(pagesPage.map(function(slug) {
                        return "".concat(prefix).concat(slug);
                    })).concat(_toConsumableArray(pageArticle.map(function(slug) {
                        return "".concat(prefix).concat(slug);
                    })));
                    return _ctx.abrupt("return", {
                        paths: paths,
                        fallback: true
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _createStaticPaths.apply(this, arguments);
}
function createStaticProps(_) {
    return _createStaticProps.apply(this, arguments);
}
function _createStaticProps() {
    _createStaticProps = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var params, includeUnpublished, slug, pageSlug, page, article, ref, upNextArticle, relatedArticles;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = param.params, includeUnpublished = param.includeUnpublished;
                    slug = params === null || params === void 0 ? void 0 : params.slug;
                    pageSlug = Array.isArray(slug) ? slug.join("/") : slug;
                    _ctx.next = 5;
                    return PageModel.findPage({
                        params: {
                            url: pageSlug
                        },
                        includeUnpublished: includeUnpublished
                    });
                case 5:
                    page = _ctx.sent;
                    if (!page) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 9;
                    return getAsyncServerSideProps(page);
                case 9:
                    return _ctx.abrupt("return", {
                        props: {
                            page: page,
                            model: "page"
                        },
                        revalidate: 5
                    });
                case 10:
                    _ctx.next = 12;
                    return ArticleModel.findArticle({
                        params: {
                            url: pageSlug
                        },
                        includeUnpublished: includeUnpublished
                    });
                case 12:
                    article = _ctx.sent;
                    if (!article) {
                        _ctx.next = 22;
                        break;
                    }
                    _ctx.t0 = _slicedToArray;
                    _ctx.next = 17;
                    return Promise.all([
                        getNextArticle(article),
                        getRelatedArticle(ArticleModel.fromBuilderContent(article)),
                        getAsyncServerSideProps(article), 
                    ]);
                case 17:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    upNextArticle = ref[0];
                    relatedArticles = ref[1];
                    return _ctx.abrupt("return", {
                        props: {
                            page: article,
                            model: "article",
                            upNextArticle: upNextArticle,
                            relatedArticles: relatedArticles
                        },
                        revalidate: 5
                    });
                case 22:
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _createStaticProps.apply(this, arguments);
}


/***/ }),

/***/ 9163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"not-found_pageNotFound__ODQu6","number":"not-found_number__TljVQ","info":"not-found_info__eH281","buttonBack":"not-found_buttonBack__CZKRo"};

/***/ })

}]);